export { default } from './reducer';
export * from './actions';
export * from './types';



// WEBPACK FOOTER //
// ./src/store/modules/modals/index.js